import { Directive, TemplateRef, ViewContainerRef, OnInit, inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Directive({
  selector: '[libIfNative]',
  standalone: true,
})
export class IfNativeDirective implements OnInit {
  private readonly templateReference = inject(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);

  ngOnInit(): void {
    if (!Capacitor.isNativePlatform()) {
      this.viewContainer.clear();
      return;
    }

    this.viewContainer.createEmbeddedView(this.templateReference);
  }
}
